import React from 'react';

const labelClass = 'block text-sm font-medium text-gray-300';
const labelClassCompact = 'block text-sm font-medium text-gray-300';
const inputClass =
  'w-full px-4 py-3 bg-black border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-600';
const inputClassCompact =
  'w-full h-9 min-h-9 px-3 text-sm bg-black border border-gray-700 rounded-md text-white placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-gray-600';

function RefreshRoundButton({ onClick, loading }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={loading}
      title={loading ? 'Refreshing...' : 'Refresh list'}
      aria-label={loading ? 'Refreshing companies' : 'Refresh company list'}
      className="inline-flex items-center justify-center text-gray-400 hover:text-white disabled:opacity-50 shrink-0 p-0.5"
    >
      <svg
        viewBox="0 0 20 20"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        className={`${loading ? 'animate-spin' : ''} h-4 w-4`}
        aria-hidden
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M3.5 10a6.5 6.5 0 0111.2-4.5M16.5 10a6.5 6.5 0 01-11.2 4.5"
        />
        <path strokeLinecap="round" strokeLinejoin="round" d="M14.2 3.2V6.5H17.5M5.8 16.8V13.5H2.5" />
      </svg>
    </button>
  );
}

export function CompanySelectField({
  companies,
  loading,
  error,
  value,
  onChange,
  onRefresh,
  name = 'company_id',
  id = 'company_id',
  label = 'Company',
  helpText,
  showHints = true,
  required = true,
  disabled = false,
  compact = false,
}) {
  return (
    <div>
      <div className={`flex items-center justify-between gap-2 ${compact ? 'mb-1' : 'mb-2'}`}>
        <label htmlFor={id} className={compact ? labelClassCompact : labelClass}>
          {label}
        </label>
        {onRefresh ? (
          <RefreshRoundButton onClick={onRefresh} loading={loading} />
        ) : null}
      </div>
      <select
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled || loading}
        className={compact ? inputClassCompact : inputClass}
      >
        <option value="">{loading ? 'Loading companies...' : 'Select a company'}</option>
        {companies.map((company) => (
          <option key={company.id} value={company.id}>
            {company.name}
          </option>
        ))}
      </select>
      {error && <p className="text-xs text-red-400 mt-1">{error}</p>}
      {showHints && !loading && !companies.length && (
        <p className="text-xs text-amber-200/90 mt-1">
          No companies yet. Add one under Add Company, then return here and click the refresh icon.
        </p>
      )}
      {showHints && !loading && companies.length > 0 && (
        <p className="text-xs text-gray-500 mt-1">
          {companies.length} {companies.length === 1 ? 'company' : 'companies'} available — including
          any you added via Add Company.
        </p>
      )}
      {showHints && helpText && <p className="text-xs text-gray-500 mt-1">{helpText}</p>}
    </div>
  );
}
